import * as services from '@api';
import { requiredValidate, BillStatusType } from '../utils';

/**
 * 审核
 * @param rootStore
 * @param options {
 *  // 必填字段
 *  cardStoreKey: string， 默认值：cardStore
 *  // 选填字段
 *  dataSourceAlias: string， 默认值：cardStore.dataSource
 * }
 * @returns
 * @hooks {
 *  // 专有钩子
 *  // 公共钩子
 *  beforeHook: 开始钩子
 *  afterHook: 结束钩子
 *  catchHook: 异常钩子
 *  finallyHook: 最终钩子
 * }
 */
export const audit = {
  async doAction(rootStore: any, options: any = {}) {
    requiredValidate.call(this, options, ['cardStoreKey']);
    const { dataSourceAlias = '', cardStoreKey = 'cardStore', successTips } = options;
    const { utils = {}, pageStore = {} } = rootStore;
    const { params = {}, query = {} } = pageStore;
    const cardStore = rootStore.get(cardStoreKey);
    if (!cardStore) throw (new Error(`The CardStore[${cardStoreKey}] not found`));
    const data = cardStore.getValue();
    try {
    // 发送请求
      pageStore?.startLoading?.()
      const res = await services.audit({
        params: {
          ...query,
          datasource: dataSourceAlias || cardStore?.dataSource || '',
          billId: options.billNo || params.billId,
          billnum: options.billNo || params.billNo,
          busiObj: options.busiObj || query.busiObj,
          mode: cardStore.uiState || pageStore.status
        },
        data: {
          data: JSON.stringify(data)
        }
      })
      cardStore.setValue(res.data, { merge: true });
      pageStore?.endLoading?.()
      utils.message.success(successTips || lang.templateByUuid('UID:P_CORE-YNF-FE_18951C6405B8002A', '审核成功'))
      return res
    } catch (err:any) {
      pageStore?.endLoading?.()
      utils.message.danger(err?.message)
      return Promise.reject(err)
    }
  }
}

/**
 * 弃审
 * @param rootStore
 * @param options {
 *  // 必填字段
 *  cardStoreKey: string， 默认值：cardStore
 *  // 选填字段
 *  dataSourceAlias: string， 默认值：cardStore.dataSource
 * }
 * @returns
 * @hooks {
 *  // 专有钩子
 *  // 公共钩子
 *  beforeHook: 开始钩子
 *  afterHook: 结束钩子
 *  catchHook: 异常钩子
 *  finallyHook: 最终钩子
 * }
 */
export const unAudit = {
  async doAction(rootStore: any, options: any = {}) {
    requiredValidate.call(this, options, ['cardStoreKey']);
    const { dataSourceAlias = '', cardStoreKey = 'cardStore', successTips } = options
    const { utils = {}, pageStore = {} } = rootStore
    const { params = {}, query = {} } = pageStore
    const cardStore = rootStore.get(cardStoreKey);
    if (!cardStore) throw (new Error(`The CardStore[${cardStoreKey}] not found`));
    const data = cardStore.getValue()
    try {
      pageStore?.startLoading?.()
      const res = await services.unAudit({
        params: {
          ...query,
          datasource: dataSourceAlias || cardStore?.dataSource || '',
          billId: options.billNo || params.billId,
          billnum: options.billNo || params.billNo,
          busiObj: options.busiObj || query.busiObj,
          mode: cardStore.uiState || pageStore.status
        },
        data: {
          data: JSON.stringify(data)
        }
      })
      cardStore.setValue(res.data, { merge: true });
      utils.message.success(successTips || lang.templateByUuid('UID:P_CORE-YNF-FE_18A243FC05A8000F', '弃审成功'))
      return res
    } catch (err: any) {
      utils.message.danger(err?.message)
      return Promise.reject(err)
    } finally {
      pageStore?.endLoading?.()
    }
  }
}
